import { usePreviousHotelSearchData } from "@/app/lib/hooks/usePreviousSearchData";
import { HotelTrackingEvents, rudderAnalytics } from "@/app/lib/rudderstack";
import { convertArabicNumberToEnglish } from "@/features/hotels/components/hotels/validation";
import { useHotelFiltersContext } from "@/features/hotels/contexts/HotelFiltersContext";
import { useHotelSearchDataContext } from "@/features/hotels/contexts/HotelSearchDataContext";
import { useHotelSortContext } from "@/features/hotels/contexts/HotelSortContext";
import type { THotelFormValues } from "@/features/hotels/types/types";

export const useHotelSearchForm = () => {
  const { resetSortValue } = useHotelSortContext();
  const { updateSearchData } = useHotelSearchDataContext();
  const { resetFilters } = useHotelFiltersContext();
  const { setPreviousSearchData } = usePreviousHotelSearchData();

  const handleSubmit = (values: THotelFormValues) => {
    rudderAnalytics.track(HotelTrackingEvents.USER_SEARCHED_FOR_OFFERS, {
      destination: values.destination?.name,
      travel_date: values.dates.checkIn,
      return_date: values.dates.checkOut,
      rooms: values.rooms,
    });
    resetFilters();
    resetSortValue();
    setPreviousSearchData(values);
    updateSearchData({
      ...values,
      rooms: values.rooms.map((room) => {
        return {
          ...room,
          childrenAges: room.childrenAges.map((childrenAge) => {
            if (typeof childrenAge === "string") {
              return convertArabicNumberToEnglish(childrenAge);
            }
            return childrenAge;
          }),
        };
      }),
    });
  };

  return { handleSubmit };
};
